import { Component, Input } from '@angular/core';

/**
 * Avatar Initial Component
 *
 * Displays a circular avatar with the first letter of a name.
 * Colors are automatically assigned based on the first letter for consistency.
 *
 * @example
 * <app-avatar-initial [name]="user.name"></app-avatar-initial>
 * <app-avatar-initial [name]="user.name" size="lg"></app-avatar-initial>
 */
@Component({
  selector: 'app-avatar-initial',
  templateUrl: './avatar-initial.component.html',
  styleUrls: ['./avatar-initial.component.scss'],
  standalone: false
})
export class AvatarInitialComponent {
  /**
   * The name to generate the initial from
   */
  @Input() name: string = '';

  /**
   * Size variant: 'sm' (24px), 'md' (32px), 'lg' (40px)
   */
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  /**
   * Optional custom class to add
   */
  @Input() customClass: string = '';

  /**
   * Get the first letter of the name (uppercase)
   */
  get initial(): string {
    return this.name?.charAt(0)?.toUpperCase() || '?';
  }

  /**
   * Get the lowercase first letter for color class
   */
  get colorClass(): string {
    const letter = this.name?.charAt(0)?.toLowerCase() || 'a';
    // Only use letters a-z for color classes
    return /^[a-z]$/.test(letter) ? `avatar-${letter}` : 'avatar-a';
  }

  /**
   * Get size class
   */
  get sizeClass(): string {
    switch (this.size) {
      case 'sm':
        return 'avatar-sm';
      case 'lg':
        return 'avatar-lg';
      default:
        return '';
    }
  }
}
